import React from 'react';
import AppLogoSVG from '../AppLogoSVG';
import AppNameSVG from '../AppNameSVG';
import './styles.css';

const Footer = () => {
  return (
    <footer className="bg-black text-gray-400 pb-20 pt-40">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-4 mt-10">
        <div className="flex gap-3">
          <AppLogoSVG isIcon={true} height={50} width={50} />
          <AppNameSVG isIcon={true} width={150} height={50} />
        </div>
        <div>
          <h3 className="text-white font-bold mb-4">Product</h3>
          <ul>
            <li className="features">Features</li>
            <li className="pricing">Pricing</li>
            <li className="faq">FAQ</li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-bold mb-4">Company</h3>
          <ul>
            <li>Terms & Conditions</li>
            <li>Privacy Policy</li>
            <li>Refund Policy</li>
            <li>Accessibility Statement</li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-bold mb-4">Credits</h3>
          <ul>
            <li>
              <a
                href="http://github.com/dKally"
                target="_blank"
                rel="noopener noreferrer"
              >
                Developer
              </a>
            </li>
            <li>
              <a
                href="https://github.com/santhws"
                target="_blank"
                rel="noopener noreferrer"
              >
                Designer
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
